module.exports = __webpack_public_path__ + "static/img/P4.fc3d377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/P4.png
// module id = SgTD
// module chunks = 0